export default __webpack_public_path__ + "static/media/B.02595077.svg";